// extracted by mini-css-extract-plugin
module.exports = {"attachmentContainer":"styles_attachmentContainer__2EQ7e"};